@use "../../styles/breakpoint.module.scss" as *;

.grid {
    composes: listReset from "../../styles/composable/utility.module.css";
    composes: safeGridContainer from "../../styles/composable/layout.module.css";
}

.column {
    grid-column: span var(--desktop-layout-col-span, 4);

    @media ($below-mobile) {
        grid-column: span var(--desktop-layout-col-span-narrow, 4);
    }
}

.spacer {
    grid-column: span var(--desktop-layout-col-span, 1);

    @media ($below-mobile) {
        display: none;
    }
}
